import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import styled from '@emotion/styled'
import AuthLayout from '../layout/AuthLayout'
import { d9Grey } from '../colors'

const S = {
  DontDisplayError: styled.div`
    background-color: ${d9Grey};
    height: 100%;
    width: 100%;
  `,
  Body: styled.div`
    width: 20rem;
    padding: 1rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  `,
}

const ErrorView = () => {
  const [displayError, setDisplayError] = useState(false)

  useEffect(() => {
    if (!displayError) {
      setTimeout(() => setDisplayError(true), 1000)
    }
  }, [displayError, setDisplayError])

  if (!displayError) {
    return <S.DontDisplayError />
  }

  return (
    <AuthLayout>
      <S.Body>
        <Typography>
          Oops! Looks like something went wrong. We've already sent a bug report
          over to the developers. Refreshing the page may fix the issue.
        </Typography>
      </S.Body>
    </AuthLayout>
  )
}

export default ErrorView
